import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { AdCategoriesTable } from "../../UI/AdCategories/AdCategoriesTable";

const AdCategories = () => {
  return (
    <div>
      <PanelHead title="AdCategories" />
      <PanelBody content={<AdCategoriesTable />} />
    </div>
  );
};

export default AdCategories;
